module.exports = __webpack_public_path__ + "01ea978f/img/at-icon.5d6fc5d8.svg";